<script>
// Tabla alternativa accesible de un gráfico (misma información que el dibujo).
export default {
  name: "DashTable",
  props: {
    caption: { type: String, required: true },
    columns: { type: Array, required: true }, // [{ key, label, align }]
    rows: { type: Array, required: true },
  },
};
</script>

<template>
  <div class="dsh-tablewrap" tabindex="0" role="region" :aria-label="caption">
    <table class="dsh-table">
      <caption class="sr-only">{{ caption }}</caption>
      <thead>
        <tr>
          <th v-for="c in columns" :key="c.key" scope="col" :class="c.align === 'right' ? 'is-num' : ''">{{ c.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(r, i) in rows" :key="i">
          <td v-for="c in columns" :key="c.key" :class="c.align === 'right' ? 'is-num' : ''">{{ r[c.key] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
